import React from 'react';
import { LockIcon } from 'lucide-react';
import { images } from '../data/kit';
interface PaymentNoteProps {
  tone?: 'light' | 'dark';
}
export function PaymentNote({
  tone = 'light'
}: PaymentNoteProps) {
  return <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2" data-id="element-280" data-mp="gxjc91wlsz1q">
      <p className={`flex items-center gap-2 text-sm ${tone === 'light' ? 'text-muted' : 'text-white/70'}`} data-id="element-281" data-mp="bz7ywh73o6er">
        <LockIcon className="h-4 w-4" aria-hidden="true" data-id="element-282" data-mp="3kgckcz6m4voi" />
        Pago seguro mediante
      </p>
      <span className="inline-flex items-center rounded-lg bg-white px-2.5 py-1.5 ring-1 ring-line" data-id="element-283" data-mp="3gerc5r50x5kn">
        <img src={images.mercadoPago} alt="Mercado Pago" className="h-6 w-auto" data-id="element-284" data-mp="3ueij57x4hlp5" />
      </span>
    </div>;
}